import React from 'react'

export const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7.50007 3.15335C6.27168 2.774 4.93419 3.09752 4.01496 3.99635C3.22054 4.77897 2.85945 5.90086 3.04824 6.99994" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.5 3.15335C17.7284 2.774 19.0659 3.09752 19.9851 3.99635C20.7795 4.77897 21.1406 5.90086 20.9518 6.99994" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.93924 5.61095C11.9283 4.37194 15.3694 5.05552 17.658 7.34292C19.9466 9.63033 20.6319 13.0711 19.3944 16.0608C18.1569 19.0505 15.2403 21.0004 12.0046 21.0012C8.76891 21.002 5.85133 19.0536 4.61232 16.0645L4.61124 16.0619C2.92126 11.9808 4.85873 7.30236 8.93924 5.61095" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.5 13.5H11.5V8.5" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
    <path d="M9.54541 25.4545L25.4545 9.54541" stroke="#8C8C8C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M25.4545 25.4546L9.54541 9.5455" stroke="#8C8C8C" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const PaperPlaneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.75426 12.149L10.5253 20.118C10.7463 21.111 12.0653 21.325 12.5883 20.453L20.8373 6.704C21.2883 5.954 20.7483 5 19.8733 5H4.32226C3.31926 5 2.81726 6.212 3.52626 6.921L8.75426 12.149Z" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.84 5.56006L8.75 12.1501" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M12.5054 13.0055H16.0068" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5054 13.0055H17.0072" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="3.00146" y="3.00122" width="18.0075" height="18.0075" rx="3" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21.009 8.00338H3.00146" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.00314 2.00085V4.00169" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.007 2.00085V4.00169" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.00293 12.7313L7.92231 13.5596L9.77308 11.8929" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5054 17.007H17.0072" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.00293 16.733L7.92231 17.5613L9.77408 15.8947" stroke="#595959" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ChevronLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
    <g clipPath="url(#clip0_16197_637)">
      <path d="M8 15L1 8L8 1" stroke="#333333" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_16197_637">
        <rect width="9" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)

export const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
    <g clipPath="url(#clip0_16194_2611)">
      <path d="M1 1L8 8L1 15" stroke="#333333" strokeWidth="1.45833" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_16194_2611">
        <rect width="9" height="16" fill="white" transform="translate(9 16) rotate(-180)"/>
      </clipPath>
    </defs>
  </svg>
)

export const ClockCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.5566 8.05542V11.5569L13.3254 13.3256" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="18.0017" cy="18.0026" r="4.00167" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.3474 17.2102L17.6667 18.8899L16.6562 17.8825" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.3183 19.5844C10.5484 20.8994 6.37006 19.4333 4.24828 16.051C2.12651 12.6688 2.62494 8.26887 5.44954 5.44696C8.27414 2.62504 12.6745 2.13079 16.0548 4.25579C19.435 6.38078 20.8971 10.5605 19.5785 14.3292" stroke="#00496E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
